import React, { useMemo } from 'react';

// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalRegularText,
} from './modalComponents';
import ticketService from '../../ticketService';
import t from './TicketUpdateTranslations';
import styled from 'styled-components';
import Star from '../ui/icon/star';

const ModalSmallText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  width: 100%;
`;

const SelectedCarrierContainer = styled.div`
  display: flex;
  height: 44px;
  padding: 12px 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-top: 1px solid var(--grey-300, #ccd6e0);
  border-bottom: 1px solid var(--grey-300, #ccd6e0);
`;

const SelectedCarrierNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const SelectedCarrierName = styled.div`
  color: var(--grey-700, #54708c);
  font-feature-settings: 'clig' off, 'liga' off;

  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
`;
const SelectedCarrierEmail = styled.div`
  color: var(--grey-700, #54708c);
  font-feature-settings: 'clig' off, 'liga' off;

  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;

const SelectedCarrierPriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SelectedCarrierPrice = styled.div`
  border-right: 1px solid var(--grey-300, #ccd6e0);
  border-left: 1px solid var(--grey-300, #ccd6e0);
  display: flex;
  padding: 0px 16px;
  align-items: center;
  gap: 10px;
`;

const SelectedCarrierRating = styled.div`
  border-left: 1px solid var(--grey-300, #ccd6e0);
  display: flex;
  padding: 0px 16px;
  align-items: center;
  gap: 10px;
`;

export const FinishCostNegotiationModal = ({ ticket, ok, cancel }) => {
  const formattedTicketId = useMemo(
    () => ticketService.utils.getFormatedId(ticket.id),
    [ticket.id]
  );

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };

  const onSubmit = () => {
    ok({});
  };

  const onChangeAssignment = (e) => {
    ok({ changeAssignment: true });
  };

  const hasOpenAuctionsWithBids = useMemo(
    () => ticketService.bussiness.hasOpenAuctionsWithBids(ticket),
    [ticket]
  );

  const selectedCarrierDetails = useMemo(() => {
    const name =
      ticket?.quote?.quote_costs[0]?.carrier?.name ||
      ticket?.quote?.operation_details?.carrier ||
      '';
    const email =
      ticket?.quote?.quote_costs[0]?.carrier?.email ||
      ticket?.quote?.operation_details?.carrier_email ||
      '';
    const price =
      ticket?.quote?.quote_costs[0]?.cost?.amount ||
      ticket?.quote?.operation_details?.cost?.amount ||
      '';
    let currency =
      ticket?.quote?.quote_costs[0]?.cost?.currency ||
      ticket?.quote?.operation_details?.cost?.currency ||
      '';
    const rating = ticket?.quote?.quote_costs[0]?.carrier?.rating || null;
    if (currency === 'EUR') {
      currency = '€';
    }

    return {
      name,
      email,
      price,
      currency,
      rating,
    };
  }, [ticket]);

  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.finishCostNegotiationConfirmationMessage} </ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalRegularText>
            {hasOpenAuctionsWithBids
              ? t.finishCostNegotiationConfirmationMessageWithBids
              : t.finishCostNegotiationConfirmationMessageWithoutBids}
          </ModalRegularText>

          <ModalSmallText>{t.assignedCarrier}</ModalSmallText>
          <SelectedCarrierContainer>
            <SelectedCarrierNameContainer>
              <SelectedCarrierName>{selectedCarrierDetails.name}</SelectedCarrierName>
              {selectedCarrierDetails.email !== '' && (
                <SelectedCarrierEmail>{selectedCarrierDetails.email}</SelectedCarrierEmail>
              )}
            </SelectedCarrierNameContainer>
            <SelectedCarrierPriceContainer>
              {selectedCarrierDetails.rating && (
                <SelectedCarrierRating>
                  <Star /> {selectedCarrierDetails.rating}
                </SelectedCarrierRating>
              )}
              <SelectedCarrierPrice>
                <SelectedCarrierName>
                  {selectedCarrierDetails.price} {selectedCarrierDetails.currency}
                </SelectedCarrierName>
              </SelectedCarrierPrice>
            </SelectedCarrierPriceContainer>
          </SelectedCarrierContainer>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={onChangeAssignment}>
          {t.changeAssignment}
        </FormButton>
        <FormButton onClick={onSubmit}>{t.finishCostNegotiation}</FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};

export default FinishCostNegotiationModal;
